import { Component, inject, DestroyRef, OnInit, ViewChild, AfterViewInit, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, NavigationEnd, RouterModule, RouterLink  } from '@angular/router';

import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

import { Observable, catchError, Subscription, throwError, firstValueFrom, EmptyError, repeat, map, mergeMap, forkJoin, of, switchMap ,first, delay, take, EMPTY} from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { FseService, FactureSearcher, FacturePreteLot, StateHelper, Virement } from '../fse.service';

import * as fselib from 'mercalink-fselib';

import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';
import { DetailRspComponent } from '@app/fse/detail-rsp/detail-rsp.component'; 
import * as util from "@app/shared/util";
import * as dao from "../fses/dao";
import * as constants from "@app/shared/constants";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-virements',
  imports: [DetailRspComponent, ReactiveFormsModule, FormsModule, RouterModule, MenuCommonComponent, MatButtonModule, MatTableModule, MatIconModule, CommonModule, MatSelectModule, MatFormFieldModule, MatInputModule],
  templateUrl: './virements.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../fse-common.scss', './virements.component.scss']
})
export class VirementsComponent implements OnInit {
  // 1. TEMPLATE Dependencies (using inject is the modern standard)
  private fseService = inject(FseService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef); // To handle unsubscription
  public stateHelper = inject(StateHelper);

  public fselib = fselib;
	public util = util;  
  public virements:Virement[]=[];
  public selectedVirement: Virement | null = null;

	public filters: dao.Filters = {
	  datdeb: '',
	  datfin: '',
	  numFacture: '',
	  recipient: '',
	  etats: [],
	  orgAmo: '',
		datcpt: '',
		paiement: '',
	};

	ngOnInit(): void {
    this.loadVirements(); // Initial Load: Run immediately on component init

    // TEMPLATE Modern way to subscribe with automatic cleanup
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => this.loadVirements());
	} 

  public loadVirements() {
    const q: string = dao.buildFilter(this.filters);
    
    return this.fseService.getRspsVirement$(q).pipe(
      map((virements: Virement[]) => {
        // We use map to transform the data structure slightly
        return virements.map(v => ({
          ...v,
          // Split by '||', trim whitespace, and remove empty results
          libVirementLines: v.libVirement
            ? v.libVirement.split('||').map(s => s.trim()).filter(s => s.length > 0)
            : []
        }));
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      this.virements = data;
    }); 
  }

  public toggleVirement(v: Virement): void {
    // If clicking the same one, close it. Otherwise, open the new one.
    if (this.selectedVirement === v) {
      this.closePanel();
    } else {
      this.selectedVirement = v;
      document.body.style.overflow = 'hidden'; // Stop background scroll
    }
  }

  public closePanel(): void {
    this.selectedVirement = null;
    document.body.style.overflow = 'auto';
  }

  public onClickExport(): void {
    const json = JSON.stringify(this.virements, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `virements_${new Date().toISOString()}.json`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

}
